import { PageRouteBuilder } from "@common/route/page-route-builder";
import { ExportLeadersOwnersComponent } from "./export-leaders-owners.component";

export const exportLeadersOwnersRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-export-leaders-owners", ExportLeadersOwnersComponent)
    .requiresLogin()
    .atUrl("/tools/export-leaders-owners")
    .withTitle("Export Leaders & Owners")
    .build();
